<template>
  <div class="closed-root">
    <VideoRoomHeader />
    <div class="closed-bg">
      <div class="closed-card">
        <div class="closed-icon-wrap">
          <div class="closed-icon">
            <img src="../assets/img/icons/video-ended.svg" width="32" height="32" alt="" />
          </div>
        </div>

        <div class="closed-card__content">
          <h1 class="closed-card__title">{{ $t('title') }}</h1>
          <p class="closed-card__text">{{ $t('description') }}</p>
        </div>

        <div class="closed-card__footer">
          <a :href="homeUrl" class="closed-btn">
            {{ $t('action') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoRoomHeader from '@/components/VideoRoomHeader.vue';
import useHomeUrl from '@/compositions/useHomeUrl';

export default {
  name: 'VideoRoomClosed',
  components: { VideoRoomHeader },
  setup() {
    return useHomeUrl();
  },
};
</script>

<style lang="scss" scoped>
.closed-root {
  min-height: 100vh;
  background: linear-gradient(160deg, #F0F4F8 0%, #EAF1F8 100%);
}

.closed-bg {
  min-height: calc(100vh - 4rem);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem 3rem;
}

.closed-card {
  width: 100%;
  max-width: 26rem;
  background: #FFFFFF;
  border-radius: 1rem;
  box-shadow: 0 4px 24px rgba(10, 130, 217, 0.08), 0 1px 4px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2.5rem 2rem 2rem;

  &__content {
    margin-bottom: 2rem;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1A1A2E;
    margin: 0 0 0.625rem;
    line-height: 1.3;
  }

  &__text {
    font-size: 0.9rem;
    color: #6B8BAF;
    line-height: 1.6;
    margin: 0;
  }

  &__footer {
    width: 100%;
    border-top: 1px solid #F0F4F8;
    padding-top: 1.5rem;
    display: flex;
    justify-content: center;
  }
}

.closed-icon-wrap {
  margin-bottom: 1.5rem;
}

.closed-icon {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(10, 130, 217, 0.08) 0%, rgba(0, 203, 243, 0.08) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0A82D9;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: -4px;
    border-radius: 50%;
    border: 1.5px solid rgba(10, 130, 217, 0.15);
  }
}

.closed-btn {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 500;
  color: #FFFFFF;
  text-decoration: none;
  background: linear-gradient(135deg, #0A82D9 0%, #00CBF3 100%);
  border-radius: 8px;
  padding: 0.65rem 1.75rem;
  box-shadow: 0 3px 10px rgba(10, 130, 217, 0.35);
  transition: box-shadow 0.25s ease, transform 0.15s ease;

  &:hover {
    box-shadow: 0 5px 18px rgba(10, 130, 217, 0.45);
    transform: translateY(-1px);
    color: #FFFFFF;
    text-decoration: none;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(10, 130, 217, 0.3);
  }
}

@media (max-width: 640px) {
  .closed-bg {
    padding: 1rem 0.75rem;
    align-items: flex-start;
    padding-top: 2rem;
  }

  .closed-card {
    padding: 2rem 1.5rem 1.5rem;
  }
}
</style>

<i18n locale="en" lang="yaml">
title: Meeting has ended
description: The organizer has ended this video interview. Thank you for your time.
action: Go to Huntica
</i18n>

<i18n locale="ru" lang="yaml">
title: Встреча завершена
description: Организатор завершил видеособеседование. Спасибо за участие.
action: Перейти на Huntica
</i18n>
